import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgenticSocAi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10.04 2.233c.145 0 .29.031.421.09l5.92 2.512a1.95 1.95 0 0 1 1.203 1.797c-.015 3.117-1.297 8.82-6.71 11.413a1.92 1.92 0 0 1-1.66 0C3.798 15.452 2.518 9.75 2.502 6.632a1.95 1.95 0 0 1 1.204-1.797l5.917-2.511q.2-.09.418-.091m3.07 5.2c-.367 0-.667.3-.667.666v4.267c0 .367.3.667.667.667.366 0 .666-.3.666-.667V8.099c0-.366-.3-.666-.666-.666m-4.267 0a.67.67 0 0 0-.61.4l-1.866 4.266a.667.667 0 0 0 1.22.533l.176-.399h2.16l.177.4a.666.666 0 0 0 1.22-.534L9.453 7.833a.67.67 0 0 0-.61-.4M9.34 10.9h-.993l.497-1.137z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAgenticSocAi;
